export default "__VITE_ASSET__492e1ccd__"